module.exports = __webpack_public_path__ + "img/header_bg_min.c2bc1e60.png";